export function isRimiOrg(org) {
  return ['rimi', 'visitcanada', 'insurecanada'].includes(org);
}

export function isCanuckProduct(source) {
  return ['rimicanuckvoyage'].includes(source);
}

export function isNonMedicalProduct(source) {
  return ['rimicanuckvoyagenonmed'].includes(source);
}

export function isInternationalStudentProduct(source) {
  return ['rimissis', 'arktrimissis', 'arkrimissis', 'visitcanadais', 'insurecanadais'].includes(source);
}

export function isVisitorToCanadaProduct(source) {
  return ['rimivisitorstocanada', 'arktrimivisitorstocanada', 'arkrimivisitorstocanada', 'visitcanadavisitors', 'insurecanadavisitor'].includes(source);
}


// WEBPACK FOOTER //
// ./src/helpers/rimi.js